import { ReactElement, useMemo } from "react";
import { ActiveFilter } from "./common";
import { IconButtonWithTitle } from "client/Components";
import { resolveFormattedTextString } from "client/Misc/utils";
import { never } from "client_legacy/ndaw/errors";
import { localize } from "client_legacy/ndaw/culture";
import { MediaQueryKind, useWorkspaceMediaQuery } from "client/Hooks";
import styles from "./HubBackButton.module.less";

export type HubBackButtonProps = {
	activeFilter: ActiveFilter | nil;
	selectedCategoryName?: string | undefined;
	shouldHideOnResponsive?: boolean;
	onBack: () => void;
};

export const HubBackButton = (props: HubBackButtonProps): ReactElement | null => {
	const {
		activeFilter,
		selectedCategoryName,
		shouldHideOnResponsive = false,
		onBack
	} = props;

	const isResponsive: boolean = useWorkspaceMediaQuery(MediaQueryKind.Responsive);

	const text = useMemo(
		(): string => {
			return activeFilter
				? getActiveFilterText(activeFilter)
				: selectedCategoryName ?? localize("_Back");
		},
		[activeFilter, selectedCategoryName]
	);

	if (isResponsive && shouldHideOnResponsive) {
		return null;
	}

	if (isResponsive) {
		return (
			<h4 className={styles.text}>
				{text}
			</h4>
		);
	}

	return (
		<IconButtonWithTitle
			title={text}
			icon="chevron-left"
			onClick={onBack}
			trackingId="page-content-back"
		/>
	);
};
HubBackButton.displayName = "HubBackButton";

function getActiveFilterText(activeFilter: ActiveFilter): string {
	switch (activeFilter.kind) {
		case "author":
			return resolveFormattedTextString({
				template: localize("_ItemsBy"),
				replacements: [
					{
						what: "{{Author}}",
						filler: activeFilter.value
							.name
					}
				]
			});
		case "tag":
			return resolveFormattedTextString({
				template: localize("_ItemsForNameTag"),
				replacements: [
					{
						what: "{{Name}}",
						filler: activeFilter.value
							.name
					}
				]
			});
		default:
			never(activeFilter);
	}
}